import React from 'react';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import useTranslate from '~/hooks/useTranslate';
import { pushToGtmLoanAction } from '~/store/actions/gtmActions';
import { updateForm } from '~/store/slices/loanOffer.slice';
import BackLink from './BackLink';

const BackToSearchLink = () => {
  const dispatch = useAppDispatch();
  const translate = useTranslate();

  const onBackToSearch = () => {
    dispatch(
      pushToGtmLoanAction({
        actionName: 'switch_to_verify_with_bank_button_pressed',
      })
    );
    dispatch(updateForm({ accountNumber: null }));
  };

  return (
    <BackLink
      label={translate('OnboardingOffer.ManualAccountBackToSearch')}
      onClick={onBackToSearch}
    />
  );
};

export default BackToSearchLink;
